module.exports = __webpack_public_path__ + "static/img/oxi.daf39da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/oxi.png
// module id = 456
// module chunks = 1